<template>
    <div>
        <div class="card shadow p-0 m-0">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.groupes', 2) }}
                    </h3>
                </div>
            </div>

            <b-container class="p-2">
                <b-row class="justify-content-sm-center p-0 m-0">
                    <div class="col-md-6">
                        Nom :  <span class="font-weight-bold"> {{ groupe.nom }}</span>
                    </div>
                    <div class="col-md-6">
                        Description :  <span class="font-weight-bold"> {{ groupe.description }}</span>
                    </div>
                    <b-col col sm="12" class="mt-5">
                        <table class="table table-hover">
                            <caption>Listes des membres du groupe</caption>
                            <thead>
                                <tr>
                                    <th class="w-50">Noms</th>
                                    <th class="w-25"> Email</th>
                                    <th class="w-25">Téléphone</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(user, index) in groupe.users" :key="index+'test'">
                                    <td>{{ user.nom }}</td>
                                    <td>{{ user.email }}</td>
                                    <td>{{ user.telephone }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "Groupe",

        computed: {
            ...mapGetters(["subscribers",'hasAdminRole',
                'hasGestionnaireRole',
                'hasPraticienRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'groupe'
            ]),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            }
        },

        data() {
            return {
                mSubscribersFilter:[],
                searchTerm : ''
            }
        },
        methods: {
            getGroupe: function() {
                let args = {
                    uuid: this.$route.params.uuid
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getGroupe', { args, errorMessages });
            },
        },

        mounted() {
           this.getGroupe();
        },

    }
</script>

<style scoped>

</style>